export default __webpack_public_path__ + "static/banner-3aed73d88ba2f8fca5f19f43eb8df554.webp";